import React from 'react'

import './FAQPage.css'
import InfoElement from './InfoElement';
import InfoElementEng from './InfoElementEng';


const NotePage: React.FC = () => {


   return (
      <>
         <h1 className='faq_title'>FAQ</h1>
         <div className='faq_page' >
            <InfoElement />
            <InfoElementEng />
         </div>
      </>
   )
}

export default NotePage;